var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('w-btn',{attrs:{"color":_vm.error ? 'red' : 'cyan',"loading":_vm.loading,"disabled":_vm.disabled,"text":_vm.$t('common.launch'),"icon":_vm.error ? 'mdi-alert' : 'mdi-clock-start'},on:{"press":_vm.press}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }